import Grid from '@mui/material/Grid';
import TextInput from '../../components/TextInput';
import React from 'react';
import { Rule } from '../../types/rule';
import useConfigStyles from '../../components/useConfigStyles';

interface RuleDetailsProps {
  rule: Rule;
  errors?: Record<string, string[]>;
  editable: boolean;
  onRuleUpdate?: (rule: Rule, fieldName: string) => void;
}

function RuleDetails({ rule, errors, editable, onRuleUpdate }: RuleDetailsProps): JSX.Element {
  const classes = useConfigStyles();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onRuleUpdate) {
      return;
    }
    const { name, value } = event.target;
    onRuleUpdate(
      {
        ...rule,
        [name]: value,
      },
      name,
    );
  };

  return (
    <Grid container alignItems='center' justifyContent='center' spacing={2} className={classes.container}>
      <Grid item className={classes.input} md={10}>
        <TextInput name='Name' label='Name' value={rule.Name} onChange={handleInputChange} errors={errors} editable={editable} />
      </Grid>
      <Grid item className={classes.input} md={10}>
        <TextInput name='ShortDescription' label='ShortDescription' value={rule.ShortDescription} onChange={handleInputChange} errors={errors} editable={editable} />
      </Grid>
      <Grid item className={classes.input} md={10}>
        <TextInput name='LongDescription' label='LongDescription' value={rule.LongDescription} onChange={handleInputChange} errors={errors} editable={editable} multiline rows={4} />
      </Grid>
      <Grid item className={classes.input} md={10}>
        { editable &&
          <ol style={{fontSize: '14px', 'marginTop': '28px'}}>
            <li>Must be valid sql that can run on the current edfi ods database.</li>
            <li>Must select LocalEducationAgency as DistrictId and SchoolId as SchoolId to filter data in job runs.</li>
          </ol>
        }
        <TextInput
          name='Statement'
          label='Statement'
          value={rule.Statement}
          onChange={handleInputChange}
          errors={errors}
          editable={editable}
          multiline
          rows={rule.Statement.split(/\r\n|\r|\n/).length > 15 ? 15 : rule.Statement.split(/\r\n|\r|\n/).length < 5 ? 5 : rule.Statement.split(/\r\n|\r|\n/).length}
        />
      </Grid>
    </Grid>
  );
}

RuleDetails.defaultProps = {
  errors: {},
  onRuleUpdate: () => {},
};

export default RuleDetails;
